export default {
      id: "circle__d-point-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#circle__d-point",
      toString: function () {
        return this.url;
      }
    }